import { InboxSorting } from "@closerplatform/spinner-openapi";
import { InboxEntryObject } from "./InboxFilter";

const sortFnOldest = (a: InboxEntryObject, b: InboxEntryObject) =>
  a.threadCreatedAt - b.threadCreatedAt;
const sortFnNewest = (a: InboxEntryObject, b: InboxEntryObject) =>
  b.threadCreatedAt - a.threadCreatedAt;

export const getSortingFunction = (
  sorting: InboxSorting
): ((a: InboxEntryObject, b: InboxEntryObject) => number) => {
  switch (sorting) {
    case InboxSorting.Newest:
      return sortFnNewest;
    case InboxSorting.Oldest:
      return sortFnOldest;
    default:
      return sortFnNewest;
  }
};
